import { styled } from "styled-components";

export const ScheduleWrapper = styled.div`
  padding: 80px 0 60px;
  @media all and (max-width: 768px) {
    padding: 8.889vw 0 7.813vw;
  }
`;

export const ScheduleContainer = styled.div`
  display: flex;
  gap: 60px;
  .contents-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 80px;

    .title-area {
      display: flex;
      flex-direction: column;
      gap: 24px;
      margin-bottom: 48px;
      & + ul {
        border-bottom: 1px solid #171717;
      }
      h3 {
        font-family: "AnekLatin-semibold";
        font-size: 72px;
        color: #171717;
      }
      p {
        font-size: 24px;
        line-height: 1.4;
        color: #242424;
      }
    }
  }
  .instructors-area {
    width: 280px;
    border-radius: 20px;
    background-color: #f7f7f7;
    border: 1px solid #efefef;
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 22px;
    padding: 32px 22px;
    > h6 {
      font-size: 20px;
      line-height: 1.4;
      font-weight: bold;
      color: #6f6f6f;
    }
    ul {
      li {
        a {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px 10px;
          i {
            width: 60px;
            height: 60px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          p {
            font-size: 16px;
            line-height: 1.5;
            font-weight: bold;
            color: #242424;
          }
        }
      }
    }
    > p {
      font-size: 14px;
      line-height: 20px;
      color: #6f6f6f;
    }
  }
  @media all and (max-width: 1024px) {
    flex-direction: column-reverse;

    .instructors-area {
      width: 100%;
      margin-top: 40px;
      ul {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        li {
          width: calc(25% - 60px / 4);
          a {
            border: 1px solid #c1c1c1;
            border-radius: 18px;
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }
  @media all and (max-width: 768px) {
    gap: 9.115vw;
    .contents-area {
      gap: 10.417vw;

      .title-area {
        gap: 3.333vw;
        margin-bottom: 8.889vw;
        h3 {
          font-size: 8vw;
          line-height: 1;
        }
        p {
          font-size: 3.556vw;
          line-height: 1.3;
        }
      }
    }
    .instructors-area {
      border-radius: 2.604vw;
      gap: 3.385vw;
      padding: 4.167vw 2.865vw;
      margin-top: 6.51vw;
      > h6 {
        font-size: 3.906vw;
      }
      ul {
        gap: 2.604vw;
        li {
          width: calc(50% - 1.302vw);
          a {
            gap: 2.604vw;
            padding: 2.604vw 2.083vw;
            i {
              width: 15.625vw;
              height: 15.625vw;
            }
            p {
              font-size: 3.646vw;
            }
          }
        }
      }
      > p {
        font-size: 3.385vw;
        line-height: 1.3;
      }
    }
  }
`;

export const ScheduleListItem = styled.li`
  padding: 20px 0;
  border-top: 1px solid #171717;
  display: flex;
  gap: 40px;
  justify-content: space-between;
  &.shuffle {
    .day-area {
      width: 210px;
    }
    .class-area {
      li {
        dl {
          dt {
            min-width: 80px;
          }
        }
      }
    }
  }
  .day-area {
    width: 100px;
    p {
      font-size: 18px;
      line-height: 1.4;
      font-weight: 700;
      color: #171717;
      &.blue {
        color: #0073cb;
      }
      &.red {
        color: #df1d1d;
      }
    }
  }
  .class-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;

      dl {
        display: flex;
        align-items: center;
        gap: 16px;
        dt {
          min-width: 140px;
          font-size: 16px;
          line-height: 1.5;
          color: #6f6f6f;
        }
        dd {
          font-size: 16px;
          line-height: 1.5;
          font-weight: bold;
          color: #171717;
        }
      }
      p {
        color: #ff784d;
        font-weight: bold;
        font-size: 16px;
        line-height: 1.5;
        min-width: 160px;
        text-align: left;
      }
    }
  }
  @media all and (max-width: 768px) {
    padding: 3.125vw 0;
    flex-direction: column;
    gap: 5.208vw;
    &.shuffle {
      .day-area {
        width: 100%;
      }
      .class-area {
        li {
          dl {
            dt {
              display: none;
            }
          }
        }
      }
    }
    .day-area {
      width: auto;
      display: flex;
      align-items: center;
      gap: 2.344vw;
      p {
        font-size: 3.906vw;
      }
    }
    .class-area {
      gap: 1.563vw;
      li {
        dl {
          gap: 2.083vw;
          dt {
            min-width: 26.042vw;
            font-size: 3.385vw;
          }
          dd {
            font-size: 3.385vw;
            max-width: 39.063vw;
            word-break: keep-all;
          }
        }
        p {
          font-size: 3.385vw;
          min-width: 28.646vw;
        }
      }
    }
  }
`;

export const ScheduleNavList = styled.ul`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  position: fixed;
  top: 100px;
  left: 0;
  width: 100%;
  background-color: #fbfbfb;
  z-index: 1;
  li {
    font-size: 24px;
    line-height: 1.3;
    font-weight: bold;
    cursor: pointer;
    color: #c1c1c1;
    &.active {
      color: #171717;
    }
  }
  @media all and (max-width: 1024px) {
    top: 80px;
  }
  @media all and (max-width: 768px) {
    top: 60px;
    gap: 5.208vw;
    height: 10.417vw;
    li {
      font-size: 3.385vw;
    }
  }
`;

export const ScheduleWrap = styled.div``;
export const ShuffleScheduleWrap = styled.div``;
